import React from 'react';
import { FaApple } from 'react-icons/fa';
import AnimateIn from './AnimateIn';

const ProcoView = () => (
  <article className="overflow-hidden bg-[#02183a] text-white">
    <div className="mx-auto grid min-h-[720px] max-w-[90rem] items-center gap-10 px-6 py-20 md:px-12 lg:grid-cols-[0.9fr_1.1fr] lg:px-16 lg:py-24">
      <AnimateIn variant="fade-up" className="relative z-10 max-w-[610px]">
        <p className="eyebrow-light">Our products</p>
        <div className="mt-4 h-1 w-20 bg-magenta" />
        <div className="mt-12 flex items-center gap-5">
          <img src={`${process.env.PUBLIC_URL}/products/procoview-icon.jpg`} alt="ProcoView icon" className="size-20 rounded-[1.35rem] shadow-lg" />
          <h2 className="text-5xl font-bold tracking-[-0.05em] sm:text-6xl lg:text-7xl">Proco<span className="text-magenta">View</span></h2>
        </div>
        <p className="mt-10 font-serif text-5xl font-medium leading-[0.98] tracking-[-0.04em] sm:text-6xl">See the moment.<br />Make the call.</p>
        <p className="mt-8 max-w-[470px] text-base leading-7 text-white/75 md:text-lg">ProcoView helps players, coaches and fans watch, review and understand the game with clarity.</p>
        <a href="https://apps.apple.com/gb/app/procoview/id6797191144" target="_blank" rel="noreferrer" className="app-store-button mt-8" aria-label="Download ProcoView on the App Store">
          <FaApple className="text-3xl" aria-hidden="true" />
          <span><small>Download on the</small>App Store</span>
        </a>
      </AnimateIn>

      <AnimateIn variant="fade-up" delay={100} className="relative mx-auto flex w-full max-w-[610px] justify-center lg:justify-end">
        <div className="w-[270px] sm:w-[310px]">
          <img src={`${process.env.PUBLIC_URL}/products/procoview-screen.png`} alt="ProcoView recording a badminton match" className="h-auto w-full" />
        </div>
      </AnimateIn>
    </div>
  </article>
);

const BringOneHome = () => (
  <article className="overflow-hidden bg-[#fffaf2] text-[#06393c]">
    <div className="mx-auto grid min-h-[720px] max-w-[90rem] items-center gap-10 px-6 py-20 md:px-12 lg:grid-cols-[0.85fr_1.15fr] lg:px-16 lg:py-24">
      <AnimateIn variant="fade-up" className="relative z-10 max-w-[590px]">
        <div className="flex items-center gap-5">
          <img src={`${process.env.PUBLIC_URL}/products/bring-one-home-mark.png`} alt="Bring One Home mark" className="size-[86px]" />
          <div>
            <h2 className="text-4xl font-extrabold leading-[0.84] tracking-[-0.055em] sm:text-5xl">Bring<br />One Home</h2>
            <div className="mt-3 h-2 w-36 bg-[#ff5845]" />
          </div>
        </div>
        <p className="mt-11 font-serif text-[3.5rem] font-medium leading-[0.9] tracking-[-0.045em] text-[#ff5845] sm:text-6xl lg:text-[4.25rem] xl:text-7xl">Community-<br />powered<br /><span className="whitespace-nowrap">lost and found</span></p>
        <p className="mt-8 max-w-[480px] text-base leading-7 text-[#173d46]/75 md:text-lg">Bring One Home makes it simple and safe to reunite lost belongings with the people who miss them.</p>
        <a href="https://bringonehome.com/" target="_blank" rel="noreferrer" className="btn-coral mt-8">Visit Bring One Home <span aria-hidden="true">→</span></a>
      </AnimateIn>

      <AnimateIn variant="fade-up" delay={100} className="relative mx-auto w-full max-w-[720px]">
        <img src={`${process.env.PUBLIC_URL}/products/bring-one-home-screens.png`} alt="Bring One Home item and claim screens" className="w-full object-contain" loading="lazy" />
      </AnimateIn>
    </div>
  </article>
);

const Platform = () => (
  <section id="products">
    <ProcoView />
    <BringOneHome />
  </section>
);

export default Platform;
